import React from 'react'
import FluidImage from 'src/utils/FluidImage'
import RichText from 'src/utils/RichText'
import { Link } from 'gatsby'
import resolveLink from '../../utils/resolveLink'
import InsightsBadge from "src/images/insights-logo.svg"
import ShortenText from 'src/utils/ShortenText'

const MagazineItem = (item) => {

    return (
        <Link to={resolveLink(`/${item.full_slug}`)} className="group" key={item.uuid}>
            <div className="group-hover:opacity-70 duration-300 relative">
                <div className={`bg-gray-100 py-2 px-3 absolute top-0 left-0 z-10 text-xs flex flex-row items-center font-body text-grey italic`}>
                    <span className={`h-[3px] w-3 inline-block mr-2 bg-darkgrey`}></span>Magazine
                </div>
                <FluidImage image={item.content.thumbnail_image} className="mb-3"/>
                <InsightsBadge className="h-12 absolute bottom-2.5 left-2.5"/>
            </div>
            <h3 className="text-darkgrey font-insights-display text-xl lg:text-lg tracking-[0.01em] mb-2 !leading-5">{item.name}</h3>
            <div className="font-insights-body text-darkgrey lg:text-[0.8rem] text-sm prose">
                <RichText>{ShortenText(item.content.description)}</RichText>
            </div>
        </Link>
    )
}

export default MagazineItem